import { Controller } from "@hotwired/stimulus";

const RESIZE_MESSAGE_TYPE = "lifetracker:resize";
const DEFAULT_WINDOW_WIDTH = 600;
const DEFAULT_WINDOW_HEIGHT = 340;

export default class extends Controller {
  static values = {
    url: String,
    width: Number,
    height: Number
  };

  async open(event) {
    event.preventDefault();

    const documentPictureInPicture = window.documentPictureInPicture;

    if (!documentPictureInPicture?.requestWindow) {
      this.openPopup();
      return;
    }

    try {
      this.closePictureInPictureWindow();

      const pipWindow = await documentPictureInPicture.requestWindow({
        width: this.windowWidth,
        height: this.windowHeight
      });

      this.pictureInPictureWindow = pipWindow;
      this.renderPictureInPictureWindow(pipWindow);
      pipWindow.addEventListener?.("pagehide", () => {
        if (this.pictureInPictureWindow === pipWindow) {
          this.pictureInPictureWindow = null;
        }
      });
    } catch (_error) {
      this.openPopup();
    }
  }

  renderPictureInPictureWindow(pipWindow) {
    const pipDocument = pipWindow.document;
    pipDocument.open();
    pipDocument.write(`<!doctype html>
      <html>
        <head>
          <title>Lifetracker</title>
          <style>
            html,
            body,
            iframe {
              width: 100%;
              height: 100%;
              margin: 0;
              border: 0;
              overflow: hidden;
            }

            body {
              background: #101010;
            }
          </style>
        </head>
        <body></body>
      </html>`);
    pipDocument.close();

    const iframe = pipDocument.createElement("iframe");
    iframe.src = this.url;
    iframe.title = "Lifetracker control view";
    pipDocument.body.appendChild(iframe);

    pipWindow.addEventListener?.("message", (event) => {
      if (event.origin !== window.location.origin) {
        return;
      }

      if (event.source !== iframe.contentWindow) {
        return;
      }

      if (event.data?.type !== RESIZE_MESSAGE_TYPE) {
        return;
      }

      this.resizePictureInPictureWindow(pipWindow, event.data);
    });
  }

  openPopup() {
    const features = [
      `width=${this.windowWidth}`,
      `height=${this.windowHeight}`,
      "noopener",
      "noreferrer",
      "toolbar=no",
      "location=no",
      "status=no",
      "menubar=no",
      "scrollbars=no",
      "resizable=no"
    ].join(",");

    window.open(this.url, "popupWindow", features);
  }

  closePictureInPictureWindow() {
    if (this.pictureInPictureWindow && !this.pictureInPictureWindow.closed) {
      this.pictureInPictureWindow.close();
    }

    this.pictureInPictureWindow = null;
  }

  resizePictureInPictureWindow(pipWindow, dimensions) {
    const multiplier = Number(dimensions.multiplier);
    const currentWidth = Number(pipWindow.outerWidth) || Number(dimensions.width) || this.windowWidth;
    const currentHeight = Number(pipWindow.outerHeight) || Number(dimensions.height) || this.windowHeight;
    const requestedWidth = multiplier > 0 ? currentWidth : Number(dimensions.width);
    const requestedHeight = multiplier > 0 ? currentHeight * multiplier : Number(dimensions.height);
    const width = Math.max(this.windowWidth, requestedWidth || this.windowWidth);
    const height = Math.max(this.windowHeight, requestedHeight || this.windowHeight);

    pipWindow.resizeTo?.(Math.ceil(width), Math.ceil(height));
  }

  get url() {
    return this.urlValue || "/games";
  }

  get windowWidth() {
    return this.widthValue || DEFAULT_WINDOW_WIDTH;
  }

  get windowHeight() {
    return this.heightValue || DEFAULT_WINDOW_HEIGHT;
  }
}
